<template>
  <div>

    <div class="col-md-6 col-md-offset-3">
      <div v-if="quiz.state != 'published'" class="note note-danger">
        <h4 class="block"> Avertissement</h4>
        <p> Vous devez publier votre questionnarie pour obtenir le lien de partage de ce dernier. <br>
          Cliquer sur le bouton "Publier" situé en bas à droite.</p>
      </div>

      <div v-if="quiz.state == 'published'" class="note note-info">
        <h4 class="block"> Félicitation</h4>
        <p> Votre questionnaire a bien été publié et est accessible à l'addresse suivante  : <br> </p><br>
        <a class="link_share" v-for="group in quiz.groups" :href="config.front_url+'questionnaire/'+quiz.slug+'?group='+group.slug" target="_blank"><h5>{{config.front_url}}questionnaire/{{quiz.slug}}?group={{group.slug}}</h5></a>
      </div>
    </div>


  </div>
</template>


<script>

  import quizzes from '../../requests/quizzes.js'
  var config = require('../../config/settings.json');


  export default {
    props: ["quiz"],
    data(){
      return{
        config:config
      }
    },
    watch:{
      'quiz.groups':function(){
        // console.log("QUIZ GROUPS EDIT",this.quiz.groups)
      }
    },
    mounted:function(){
      // console.log("QUI GROUPZ",this.quiz.groups);
      this.$forceUpdate();
    },
    methods:{
    }
  }
</script>
<style scoped>
  .link_share{
    color:#5f524c
  }
</style>



// WEBPACK FOOTER //
// share_quiz.vue?08be4b7e